import React from 'react';

import { FeatureFlagsContext } from './FeatureFlagsContext';

export const useFeatureFlagsContext = () => React.useContext(FeatureFlagsContext);
